<div class="launch-container">
  <p class="m-0 filtered-auction-start-at start-at">Aukcja trwa:</p>

  <div class="timer">
    @for (unit of timeUnits(); track $index; let first = $first) {
    <div class="time-box">
      <div class="flip-card">
        <div class="time-value">{{ unit?.value }}</div>
      </div>
      <div class="time-label">{{ unit?.label }}</div>
    </div>
    }
  </div>
</div>
